import { Info } from "lucide-react";
import type { FC, ReactNode } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface HintProps {
  classes?: string;
  children?: ReactNode | string;
}

const CustomTooltip: FC<HintProps> = ({ children, classes }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help position-relative">
            <Info size={10} className="mr-[7px] size-[10px]" />
          </span>
        </TooltipTrigger>
        <TooltipContent
          className={cn(
            "max-w-50 bg-gray-950 text-sm text-zinc-50 px-3 py-2 rounded-[6px]",
            classes
          )}
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CustomTooltip;
